// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/favicon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/images/typing-crop2.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/images/user.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

body {
  background-color: #edeff2;
  font-family: "Calibri", "Roboto", sans-serif;
}

.row.padded_row,
.row.padded_row > div {
  padding-top: 20px;
  padding-bottom: 20px;
}

/* layout and common global classes */
/* ---------------------------------------------------------------------- */

.chat_window {
  border-radius: 10px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
  background-color: #f8f8f8;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.top_menu {
  background-color: #fff;
  padding: 13px 0px;
  box-shadow: 0 1px 30px rgba(0, 0, 0, 0.1);
}

.top_menu .title {
  text-align: center;
  color: #337ab7;
  font-size: 20px;
}

.dropdown-menu {
  z-index: 1050 !important;
}

/* messages inside the chatbox */
/* ---------------------------------------------------------------------- */

.messages {
  position: relative;
  list-style: none;
  padding: 20px 10px 0 10px;
  margin: 0;
  height: 400px;
  overflow-y: scroll;
}

.messages .message {
  clear: both;
  overflow: hidden;
  margin-bottom: 20px;
  transition: all 0.5s linear;
  opacity: 0;
}

.messages .message .avatar {
  height: 40px;
  width: 40px;
  background-size: cover !important;
  border-radius: 50%;
  display: inline-block;
}

.messages .message .l-gif {
  width: 50px;
  height: 40px;
  background-size: contain !important;
  background-repeat: no-repeat;
  background-position: center;
  display: inline-block;
  margin-left: 10px;
}

.messages .message .timestamp {
  font-size: 10px;
  font-weight: 300;
  text-align: right;
  margin-top: 5px;
}

.messages .message.appeared {
  opacity: 1;
}

.messages .message .text_wrapper {
  display: inline-block;
  padding: 20px;
  border-radius: 6px;
  min-width: 150px;
  position: relative;
}

.messages .message .text_wrapper::after,
.messages .message .text_wrapper:before {
  top: 18px;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.messages .message .text_wrapper::after {
  border-width: 13px;
  margin-top: 0px;
}

.messages .message .text_wrapper::before {
  border-width: 15px;
  margin-top: -2px;
}

/* bot message */

.messages .message.left .avatar {
  float: left;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.l-gif {
  float: left;
  height: 50px;
  width: 50px;
  background-size: contain !important;
  background-repeat: no-repeat;
  background-position: center;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.messages .message.left .text_wrapper {
  background-color: #f9e9a6;
  margin-left: 20px;
}

.messages .message.left .text_wrapper::after,
.messages .message.left .text_wrapper::before {
  right: 100%;
  border-right-color: #f9e9a6;
}

.messages .message.left .timestamp {
  color: #b99500;
}

/* user message */

.messages .message.right .avatar {
  float: right;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.messages .message.right .text_wrapper {
  background-color: #b9d2b0;
  margin-right: 20px;
  float: right;
}

.messages .message.right .text_wrapper::after,
.messages .message.right .text_wrapper::before {
  left: 100%;
  border-left-color: #b9d2b0;
}

.messages .message.right .timestamp {
  color: #52823f;
}

/* text inpur from user */

.bottom_wrapper {
  background-color: #fff;
  padding: 20px;
  bottom: 0;
  display: flex;
}

.bottom_wrapper #msg_input {
  flex-grow: 1;
  outline-width: 0;
  padding: 12px;
  border: 1px solid #bcbdc0;
  border-radius: 50px;
  margin-right: 15px;
}

/* Beim Klick/Fokus */
.bottom_wrapper #msg_input:focus {
  border-color: #b9d2b0;
  border-width: 2px;
  box-shadow: 0 0 1px #b9d2b0;
  outline: none;
}

.app_button_1 {
  width: 140px;
  background-color: #009036;
  border-radius: 50px;
  cursor: pointer;
  padding: 12px;

  color: #fff;
  font-size: 18px;
  font-weight: 300;
  text-align: center;
}

.saveBtn {
  background-color: #e2001a;

  color: #fff;
}

/* Functions that the text breaks correctly*/

.message {
  display: flex;
  align-items: flex-start;
}

.message.left {
  justify-content: flex-start;
}

.message.right {
  justify-content: flex-end;
}
/*Source: https://stackoverflow.com/questions/67858284/how-to-have-one-item-shrink-fully-before-another-starts-to-shrink */
.avatar {
  flex-shrink: 0;
  flex-grow: 0;
}

.text_wrapper {
  flex-shrink: 1;
  flex-grow: 0;
  flex-basis: auto;
  min-width: 0;
}

/* faq section | right side */
/* ---------------------------------------------------------------------- */

.panel-group {
  padding: 5px;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  min-height: 500px;
}

.panel-group > div {
  width: calc(100% - 10px) !important;
  flex: 1 1;
}

.panel-heading [data-toggle="collapse"]:after {
  font-family: "FontAwesome";
  content: "\\f054";
  float: right;
  font-size: 18px;
  line-height: 22px;
  transition: all 0.2s linear;
  transform: rotate(-90deg);
}

.panel-heading [data-toggle="collapse"].collapsed:after {
  transform: rotate(90deg);
}

/*API  Key Modal*/
.modal-backdrop-custom {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-box {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 400px;
}

.top_menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/chat.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;;EAEE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC,2EAA2E;;AAE3E;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC,2EAA2E;;AAE3E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gBAAgB;;AAEhB;EACE,WAAW;EACX,mDAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mCAAmC;EACnC,4BAA4B;EAC5B,2BAA2B;EAC3B,mDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;;AAEjB;EACE,YAAY;EACZ,mDAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;;AAEzB;EACE,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;;EAEb,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;;EAEzB,WAAW;AACb;;AAEA,4CAA4C;;AAE5C;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;AACA,0HAA0H;AAC1H;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA,6BAA6B;AAC7B,2EAA2E;;AAE3E;EACE,YAAY;EACZ,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,SAAO;AACT;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAM3B,yBAAyB;AAC3B;;AAEA;EAKE,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nbody {\n  background-color: #edeff2;\n  font-family: \"Calibri\", \"Roboto\", sans-serif;\n}\n\n.row.padded_row,\n.row.padded_row > div {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n/* layout and common global classes */\n/* ---------------------------------------------------------------------- */\n\n.chat_window {\n  border-radius: 10px;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);\n  background-color: #f8f8f8;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n}\n\n.top_menu {\n  background-color: #fff;\n  padding: 13px 0px;\n  box-shadow: 0 1px 30px rgba(0, 0, 0, 0.1);\n}\n\n.top_menu .title {\n  text-align: center;\n  color: #337ab7;\n  font-size: 20px;\n}\n\n.dropdown-menu {\n  z-index: 1050 !important;\n}\n\n/* messages inside the chatbox */\n/* ---------------------------------------------------------------------- */\n\n.messages {\n  position: relative;\n  list-style: none;\n  padding: 20px 10px 0 10px;\n  margin: 0;\n  height: 400px;\n  overflow-y: scroll;\n}\n\n.messages .message {\n  clear: both;\n  overflow: hidden;\n  margin-bottom: 20px;\n  transition: all 0.5s linear;\n  opacity: 0;\n}\n\n.messages .message .avatar {\n  height: 40px;\n  width: 40px;\n  background-size: cover !important;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.messages .message .l-gif {\n  width: 50px;\n  height: 40px;\n  background-size: contain !important;\n  background-repeat: no-repeat;\n  background-position: center;\n  display: inline-block;\n  margin-left: 10px;\n}\n\n.messages .message .timestamp {\n  font-size: 10px;\n  font-weight: 300;\n  text-align: right;\n  margin-top: 5px;\n}\n\n.messages .message.appeared {\n  opacity: 1;\n}\n\n.messages .message .text_wrapper {\n  display: inline-block;\n  padding: 20px;\n  border-radius: 6px;\n  min-width: 150px;\n  position: relative;\n}\n\n.messages .message .text_wrapper::after,\n.messages .message .text_wrapper:before {\n  top: 18px;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n\n.messages .message .text_wrapper::after {\n  border-width: 13px;\n  margin-top: 0px;\n}\n\n.messages .message .text_wrapper::before {\n  border-width: 15px;\n  margin-top: -2px;\n}\n\n/* bot message */\n\n.messages .message.left .avatar {\n  float: left;\n  background: url(\"../assets/images/favicon.png\");\n}\n\n.l-gif {\n  float: left;\n  height: 50px;\n  width: 50px;\n  background-size: contain !important;\n  background-repeat: no-repeat;\n  background-position: center;\n  background: url(\"../assets/images/typing-crop2.gif\");\n}\n\n.messages .message.left .text_wrapper {\n  background-color: #f9e9a6;\n  margin-left: 20px;\n}\n\n.messages .message.left .text_wrapper::after,\n.messages .message.left .text_wrapper::before {\n  right: 100%;\n  border-right-color: #f9e9a6;\n}\n\n.messages .message.left .timestamp {\n  color: #b99500;\n}\n\n/* user message */\n\n.messages .message.right .avatar {\n  float: right;\n  background: url(\"../assets/images/user.png\");\n}\n\n.messages .message.right .text_wrapper {\n  background-color: #b9d2b0;\n  margin-right: 20px;\n  float: right;\n}\n\n.messages .message.right .text_wrapper::after,\n.messages .message.right .text_wrapper::before {\n  left: 100%;\n  border-left-color: #b9d2b0;\n}\n\n.messages .message.right .timestamp {\n  color: #52823f;\n}\n\n/* text inpur from user */\n\n.bottom_wrapper {\n  background-color: #fff;\n  padding: 20px;\n  bottom: 0;\n  display: flex;\n}\n\n.bottom_wrapper #msg_input {\n  flex-grow: 1;\n  outline-width: 0;\n  padding: 12px;\n  border: 1px solid #bcbdc0;\n  border-radius: 50px;\n  margin-right: 15px;\n}\n\n/* Beim Klick/Fokus */\n.bottom_wrapper #msg_input:focus {\n  border-color: #b9d2b0;\n  border-width: 2px;\n  box-shadow: 0 0 1px #b9d2b0;\n  outline: none;\n}\n\n.app_button_1 {\n  width: 140px;\n  background-color: #009036;\n  border-radius: 50px;\n  cursor: pointer;\n  padding: 12px;\n\n  color: #fff;\n  font-size: 18px;\n  font-weight: 300;\n  text-align: center;\n}\n\n.saveBtn {\n  background-color: #e2001a;\n\n  color: #fff;\n}\n\n/* Functions that the text breaks correctly*/\n\n.message {\n  display: flex;\n  align-items: flex-start;\n}\n\n.message.left {\n  justify-content: flex-start;\n}\n\n.message.right {\n  justify-content: flex-end;\n}\n/*Source: https://stackoverflow.com/questions/67858284/how-to-have-one-item-shrink-fully-before-another-starts-to-shrink */\n.avatar {\n  flex-shrink: 0;\n  flex-grow: 0;\n}\n\n.text_wrapper {\n  flex-shrink: 1;\n  flex-grow: 0;\n  flex-basis: auto;\n  min-width: 0;\n}\n\n/* faq section | right side */\n/* ---------------------------------------------------------------------- */\n\n.panel-group {\n  padding: 5px;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  min-height: 500px;\n}\n\n.panel-group > div {\n  width: calc(100% - 10px) !important;\n  flex: 1;\n}\n\n.panel-heading [data-toggle=\"collapse\"]:after {\n  font-family: \"FontAwesome\";\n  content: \"\\f054\";\n  float: right;\n  font-size: 18px;\n  line-height: 22px;\n  transition: all 0.2s linear;\n\n  -webkit-transform: rotate(-90deg);\n  -moz-transform: rotate(-90deg);\n  -ms-transform: rotate(-90deg);\n  -o-transform: rotate(-90deg);\n  transform: rotate(-90deg);\n}\n\n.panel-heading [data-toggle=\"collapse\"].collapsed:after {\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n/*API  Key Modal*/\n.modal-backdrop-custom {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.modal-box {\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  width: 400px;\n}\n\n.top_menu {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
